import { useMemo } from 'react';
import { Invoice } from '../../types/invoice';
import getInvoiceStatusLabel from '../../util/get-invoice-status-label';
import Badge, { BADGE_COLOR } from '../badge/badge';

interface InvoiceStatusProps {
    children?: Invoice['status'];
}

export default function InvoiceStatus(props: InvoiceStatusProps) {
    const invoiceStatus = useMemo(() => props.children, [props.children]);

    const badgeColor = useMemo(() => {
        switch (invoiceStatus) {
            case 'pending':
                return BADGE_COLOR.YELLOW;
            case 'certified':
                return BADGE_COLOR.GREEN;
            case 'cancelled':
                return BADGE_COLOR.GRAY;
            case 'validationError':
                return BADGE_COLOR.YELLOW;
            case 'failed':
                return BADGE_COLOR.RED;
            case 'rejected':
                return BADGE_COLOR.RED;
            default:
                return BADGE_COLOR.GRAY;
        }
    }, [invoiceStatus]);

    return <Badge color={badgeColor}>{getInvoiceStatusLabel(invoiceStatus)}</Badge>;
}
